import './modals/modal-delete-company.component.js';

import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

import gridHeight from '../core/shared-service/grid-utils';

class companiesDetailsCtrl {
    /* @ngInject */
    constructor(
        $uibModal,
        $state,
        AuthSvc,
        logger,
        $translate,
        $filter,
        $window,
        uiGridExporterConstants,
        RegistrationScheme,
        LegalEntityPerimeter,
        PrincipalSvc,
        Country,
        RegistrationSchemesDA,
        CompanyCreationContextResult,
        linkRequestSvc,
        LINK_REQUEST,
        CompanyPlatform,
        $scope,
        $rootScope,
        DEMATMODE,
        $q
    ) {
        const PERIMETER_UPDATED_EVENT = 'perimeters:updated';
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.$translate = $translate;
        this.$filter = $filter;
        this.$window = $window;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.RegistrationScheme = RegistrationScheme;
        this.LegalEntityPerimeter = LegalEntityPerimeter;
        this.PrincipalSvc = PrincipalSvc;
        this.Country = Country;
        this.RegistrationSchemesDA = RegistrationSchemesDA;
        this.CompanyCreationContextResult = CompanyCreationContextResult;
        this.linkRequestSvc = linkRequestSvc;
        this.LINK_REQUEST = LINK_REQUEST;
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.TIME_MASK = { h: 0, m: 0, s: 0, ms: 0 };
        this.COUNTRY_CODE_ES = 'ES';
        this.ROLE_CONFIGURATOR = 'CONFIGURATOR';
        this.CompanyPlatform = CompanyPlatform;
        this.filteredOptions1 = [];
        this.filteredOptions2 = [];
        this.filtredAttributes = [];
        this.$scope = $scope;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$rootScope.$on(PERIMETER_UPDATED_EVENT, (event, updatedPerimeter) => {
            const allPerimeters = Array.from(this.legalEntity.perimeters || []);
            const existingIndex = allPerimeters.findIndex(perimeter => perimeter.code === updatedPerimeter.code);
            if (existingIndex !== -1) {
                allPerimeters[existingIndex] = updatedPerimeter;
            } else {
                allPerimeters.push(updatedPerimeter);
            }
            this.gridPerimeterOptions.columnDefs[2].visible = allPerimeters.some(perimeter => perimeter.isConfidential);
        });
        this.DEMATMODE = DEMATMODE;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.todayDate = moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK);
        this.legalEntityResolved = this.legalEntity;
        this._initialLegalEntity = angular.copy(this.legalEntityResolved);
        this.legalEntity = angular.copy(this.legalEntityResolved);
        this.langs = this.PrincipalSvc.getLangs();
        this.canShowPeppolReception = this.legalEntityResolved.countryCode == 'BE';
        this.principal = angular.copy(this.principal);
        if (this.isUpdating()) {
            this.linkRequestSvc
                .getLinkRequestCount(this.legalEntity.id, this.LINK_REQUEST.TYPE.fournisseur)
                .then(data => (this.linkRequestCount = data));
        }

        this.platformChoice = 'do';
        this.ePlatformChoice = 'do';
        // Demat plateforms
        this.idGisPlatformFocused = false;
        this.gisPlatformSelected = false;
        this.pasrelPlatformSelected = false;
        //platform config via legal entity
        this.gisPlatform = new this.CompanyPlatform();
        this.pasrelPlatform = new this.CompanyPlatform();
        //platform config via DO
        this.doGisPlatform = new this.CompanyPlatform();
        this.doPasrelPlatform = new this.CompanyPlatform();
        this.gisPlatformName = 'GIS';
        this.pasrelPlatformName = 'PASREL';
        this.initPlatformData();
        this.getOffreApiConfig();
        //offreApi
        this.previousFirstSelectorState = null;

        this.previousSecondSelectorState = null;

        var cellTemplateDefaultPerimeter =
            '<div class="ui-grid-cell-contents" ng-click="grid.appScope.$ctrl.updatePerimeter(row)">{{COL_FIELD CUSTOM_FILTERS}}</div>';

        var cellTemplateBooleanPerimeter =
            '<div class="ui-grid-cell-contents" ng-click="grid.appScope.$ctrl.updatePerimeter(row)">{{(COL_FIELD CUSTOM_FILTERS ? "YES" : "NO")|translate}}</div>';
        // Gestion de la grille des périmètres
        this.gridPerimeterOptions = {
            columnDefs: [
                {
                    name: 'code',
                    displayName: 'ID',
                    cellClass: 'pointer',
                    sort: { direction: 'asc', priority: 1 },
                    cellTemplate: cellTemplateDefaultPerimeter,
                },
                {
                    name: 'name',
                    displayName: 'Libellé',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultPerimeter,
                },
                {
                    name: 'isConfidential',
                    displayName: 'Confidentiel',
                    cellClass: 'pointer',
                    sort: { direction: 'asc' },
                    cellTemplate: cellTemplateBooleanPerimeter,
                    visible:
                        this.legalEntity.perimeters != null &&
                        this.legalEntity.perimeters.some(element => element.isConfidential),
                },
                {
                    name: 'beginDate',
                    displayName: 'Début validité',
                    cellClass: 'pointer',
                    cellFilter: "date: 'shortDate'",
                    enableSorting: false,
                    cellTemplate: cellTemplateDefaultPerimeter,
                },
                {
                    name: 'endDate',
                    displayName: 'Fin validité',
                    cellClass: 'pointer',
                    cellFilter: "date: 'shortDate'",
                    enableSorting: false,
                    cellTemplate: cellTemplateDefaultPerimeter,
                },
            ],
            enableColumnMenus: false,
            enableSorting: true,
            enableGridMenu: false,
            rowHeight: 30,
            exporterOlderExcelCompatibility: true,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
            },
        };

        // this.getPerimeterGridHeight = this.getGridHeight();

        var cellTemplateDefaultContainer =
            '<div class="ui-grid-cell-contents" ng-click="grid.appScope.$ctrl.updateContainer(row)">{{COL_FIELD CUSTOM_FILTERS}}</div>';
        var containerModeCellTemplate =
            '<div class="ui-grid-cell-contents" ng-click="grid.appScope.$ctrl.updateContainer(row)">{{"container_mode." + COL_FIELD | translate}}</div>';
        // Gestion de la grille des containers
        this.gridContainerOptions = {
            columnDefs: [
                {
                    name: 'containerId',
                    displayName: 'ID',
                    cellClass: 'pointer',
                    sort: { direction: 'asc', priority: 1 },
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'perimeterCode',
                    displayName: 'Périmètre',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'containerMode',
                    displayName: 'Application',
                    cellClass: 'pointer',
                    cellTemplate: containerModeCellTemplate,
                },
                {
                    name: 'getContainerTypeTranslated()',
                    displayName: 'Type',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'getDematModeTranslated()',
                    displayName: 'Mode Démat',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'getTreatment()',
                    displayName: 'Traitement',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'ladProviderName',
                    displayName: 'Prestataire',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
                {
                    name: 'getContainerStatusTranslated()',
                    displayName: 'Statut',
                    cellClass: 'pointer',
                    cellTemplate: cellTemplateDefaultContainer,
                },
            ],
            enableColumnMenus: false,
            enableSorting: true,
            enableGridMenu: false,
            rowHeight: 30,
            exporterOlderExcelCompatibility: true,
            onRegisterApi: gridApi => {
                this.containerGridApi = gridApi;
            },
        };
        // Gestion de la grille des lisibles
        this.initReadableGrid();
        // this.gridContainerOptions.onRegisterApi = this.onRegisterContainerApi();
        this.initRegSchemes();
        this.initPlatformChoice();
        this._activate();
        this.checkDocumentySpaceExist = true;
        this.shwoPdpRe = this.canEditPdpRe();
        this.shwoPdpEm = this.canEditPdpEm();
        this.shwoBillingAdress = this.canShowBillingAdress();
        this.showOffreApi = this.hasOffreApiConfig();
        this.showMandateSii = this.hasMandateSiiConfig();
        this.isConfigurator = this.isConfigurator();
        if (this.shwoPdpRe) {
            this.isDatePdpReChanged = this.datePdpReChanged();
            this.pdpReIsActive = this.isPdpReActive();
            this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
            this.statusPpfReSend = this.statusPpfReSend();
            this.isDateEreportingReChanged = this.dateEreportingReChanged();
            this.eReportingReIsActive = this.isEreportingReActive();
            this.canEditStartDateEreportingRe = this.isEditableStartDateEreportingRe();
        }
        if (this.shwoPdpEm) {
            this.isDatePdpEmChanged = this.datePdpEmChanged();
            this.pdpEmIsActive = this.isPdpEmActive();
            this.canEditStartDatePdpEm = this.isEditableStartDatePdpEm();
            this.statusPpfEmSend = this.statusPpfEmSend();
            this.isDateEreportingEmChanged = this.dateEreportingEmChanged();
            this.eReportingEmIsActive = this.isEreportingEmActive();
            this.canEditStartDateEreportingEm = this.isEditableStartDateEreportingEm();
        }
        if (this.shwoPdpRe && this.legalEntity.ereporting) {
            this.buyerSetting = this.legalEntity.ereporting.buyerSetting;
        } else {
            this.buyerSetting = {
                transactionComplete: false,
                startDate: null,
                endDate: null,
            };
        }
        if (this.shwoPdpEm && this.legalEntity.ereporting) {
            this.sellerSetting = this.legalEntity.ereporting.sellerSetting;
        } else {
            this.sellerSetting = {
                transactionComplete: false,
                paymentComplete: false,
                startDate: null,
                endDate: null,
            };
        }
        if (this.shwoPdpEm || this.shwoPdpRe) {
            this.legalEntity.ereporting = {
                sellerSetting: this.sellerSetting,
                buyerSetting: this.buyerSetting,
            };
        }
        // Récupérer que les attributs sont de type texte et numérique
        this.filtredAttributes = this.dictionnaireAttributs.filter(a => a.type === 'Number' || a.type === 'Text');
        this.filterOptionsForSelector2();
        this.filterOptionsForSelector1();
        this.isDOCL = this.principal.detail.profilBuyer;
        this.isDOFO = this.principal.detail.profilSeller;
        this.getRequestDto = {};
        this.getReadableData();

    }

    /**
     * Ajoute ou soustrait un jour à une date passée en paramètre
     * @param {Date} date La date à modifier
     * @param {number} daysToAdd Le nombre de jours à ajouter ou soustraire (utiliser un nombre négatif pour soustraire des jours)
     */
    modifyDateByDays(date, daysToAdd) {
        const number = 'number';
        if (date != null && typeof daysToAdd === number) {
            return moment(date).add(daysToAdd, 'days');
        }
    }

    /**
     * Permet de vérifier si la famille de la plateforme GIS est selectionnée pour le DO
     */
    isGisPlatformSelected() {
        return this.principal.detail.isPlatformSelected('GIS');
    }
    /**
     * Permet de vérifier si la famille de la plateforme PASREL est selectionnée pour le DO
     */
    isPasrelPlatformSelected() {
        return this.principal.detail.isPlatformSelected('PASREL');
    }
    isTransactionEreportingEmDisabled() {
        if (this.legalEntity.ereporting == null || this.legalEntity.ereporting.sellerSetting == null) return false;
        return this.legalEntity.ereporting.sellerSetting.transactionComplete;
    }
    isPaymentEreportingEmDisabled() {
        if (this.legalEntity.ereporting == null || this.legalEntity.ereporting.sellerSetting == null) return false;
        return this.legalEntity.ereporting.sellerSetting.paymentComplete;
    }
    isTransactionEreportingReDisabled() {
        if (this.legalEntity.ereporting == null || this.legalEntity.ereporting.buyerSetting == null) return false;
        return this.legalEntity.ereporting.buyerSetting.transactionComplete;
    }
    uncheckAllEreportingEm() {
        this.sellerSetting = {
            transactionComplete: false,
            paymentComplete: false,
            startDate: null,
            endDate: null,
        };
    }
    uncheckAllEreportingRe() {
        this.buyerSetting = {
            transactionComplete: false,
            startDate: null,
            endDate: null,
        };
    }
    ////////////////
    _activate() {
        if (this.legalEntity.perimeters) {
            this.gridPerimeterOptions.data = this.legalEntity.perimeters;
        }
        if (this.legalEntity.containers) {
            this.gridContainerOptions.data = this.legalEntity.containers;
        }
        if (!this.legalEntity.idFiscalKind) {
            this.idFiscalKindSelect = new this.RegistrationScheme({ code: 'na', scope: 'fiscal' });
        } else {
            this.idFiscalKindSelect = new this.RegistrationScheme({
                code: this.legalEntity.idFiscalKind,
                scope: 'fiscal',
            });
        }
        if (!this.legalEntity.idNationalKind) {
            this.idNationalKindSelect = new this.RegistrationScheme({ code: 'none', scope: 'national' });
        } else {
            this.idNationalKindSelect = new this.RegistrationScheme({
                code: this.legalEntity.idNationalKind,
                scope: 'national',
            });
        }
        this.legalEntity.country = new this.Country({ code: this.legalEntity.countryCode, fromEU: false });
        if (this.legalEntity.id) {
            this.isCompanyDeletable();
        }
    }

    // Type identifiants fiscaux/nationaux
    initRegSchemes() {
        // Pas d'identifiant : Non assujeti
        var _naRegScheme = new this.RegistrationScheme({ code: 'na', scope: 'fiscal' });
        // Pas d'identifiant légal
        var _noneRegScheme = new this.RegistrationScheme({ code: 'none', scope: 'national' });
        this.fiscalRegSchemes = _.filter(this.regSchemes, { scope: 'fiscal' });
        this.natRegSchemes = _.filter(this.regSchemes, { scope: 'national' });
        // Add default value
        this.fiscalRegSchemes.push(_naRegScheme);
        this.natRegSchemes.push(_noneRegScheme);
    }

    onIdFiscalKindChange() {
        if (!this.idFiscalKindSelect || this.idFiscalKindSelect.code === 'na') {
            this.legalEntity.idFiscalKind = null;
            this.legalEntity.idFiscal = null;
        } else {
            this.legalEntity.idFiscalKind = this.idFiscalKindSelect.code;
        }
    }

    onIdNationalKindChange() {
        if (!this.idNationalKindSelect || this.idNationalKindSelect.code === 'none') {
            this.legalEntity.idNational = null;
            this.legalEntity.idNationalKind = null;
        } else {
            this.legalEntity.idNationalKind = this.idNationalKindSelect.code;
        }
    }

    getGridHeight(gridApi, withOffset = true) {
        return gridHeight(gridApi, withOffset);
    }

    updatePerimeter(row) {
        this.openPerimeterModal(new this.LegalEntityPerimeter(row.entity), true);
    }

    openPerimeterModal(legalEntityPerimeter, update) {
        this.$uibModal
            .open({
                component: 'legalEntityPerimeter',
                size: 'lg',
                resolve: {
                    update: () => {
                        return update;
                    },
                    principal: () => {
                        return this.principal;
                    },
                    legalEntity: () => {
                        return this.legalEntity;
                    },
                    legalEntityPerimeter: () => {
                        return legalEntityPerimeter;
                    },
                },
            })
            .result.then(
                res => {
                    this.closeModal(res);
                },
                () => {
                    this.dismissModal();
                }
            );
    }

    /** Mise à jour du tableau. */
    closeModal(res) {
        this.legalEntity.perimeters = this.gridPerimeterOptions.data;
        if (res.deleted || res.updated) {
            let index = this.legalEntity.perimeters.findIndex(perimeter => perimeter.code === res.perimeter.code);
            if (res.deleted) {
                this.legalEntity.perimeters.splice(index, 1);
            } else {
                this.legalEntity.perimeters[index] = res.perimeter;
            }
        } else {
            this.legalEntity.perimeters.push(res.perimeter);
        }
    }

    dismissModal(/*reason*/) {}

    back() {
        this.$window.history.back();
    }

    createNewContainer() {
        this.$state.go('app.principal.consult.detailscontainer', {
            mode: 'new',
            principalId: this.principal.detail.id,
            companyId: this.legalEntity.id,
            containerMode: this.principal.epdf.ladProviderEid ? 'STANDARD' : 'KISS',
        });
    }

    updateContainer(row) {
        this.$state.go('app.principal.consult.updatecontainer', {
            mode: 'details',
            containerId: row.entity.containerId,
        });
    }

    viewRelationsShip(/*row*/) {
        var principalInfo = {
            corporateName: null,
            eid: null,
        };
        var companyInfo = {
            id: null,
            name: null,
        };
        if (this.principal && this.principal.detail) {
            principalInfo.corporateName = this.principal.detail.corporateName;
            principalInfo.eid = this.principal.detail.eid;
        }
        if (this.legalEntity) {
            companyInfo.id = this.legalEntity.id;
            companyInfo.name = this.legalEntity.name;
        }
        this.$state.go('app.principal.companyrelations', {
            id: this.legalEntity.id,
            principalInfo: principalInfo,
            companyInfo: companyInfo,
        });
    }

    cancel() {
        this.legalEntity = angular.copy(this.legalEntityResolved);
        this._activate();
    }

    onEPathChange() {
        this.form.ePlatformPath.$setValidity('platformPathEInvoiceNotExist', true);
    }

    save() {
        if (this.getDematPlatform() === 'GIS' && this.legalEntity.dematGisId) {
            this.checkConfirmModal();
        } else {
            this.proceedSave(this.isUpdating());
        }
    }

    proceedSave(shouldUpdate) {
        this.validatePaths().then(isValid => {
            if (isValid) {
                shouldUpdate ? this.update() : this.create();
            }
        });
    }
    getDematPlatform() {
        var dematPlatform;
        if (this.legalEntity.id) {
            dematPlatform = this.legalEntity.dematPlatform;
        } else {
            dematPlatform = this.principal.detail.plateform;
        }
        return dematPlatform;
    }

    getOffreApiConfig() {
        if (!this.legalEntity.id) {
            this.legalEntity.offresApi = this.offresApiConfig;
        }
    }

    checkConfirmModal() {
        this.PrincipalSvc.checkGisPlatformId(this.legalEntity, this.principal.detail.eid).then(
            res => {
                if (
                    res &&
                    (res.siren != this.legalEntity.idNational ||
                        res.tvaIntraco != this.legalEntity.idFiscal ||
                        res.company != this.principal.detail.eid)
                ) {
                    this.$uibModal
                        .open({
                            component: 'checkIdGisModal',
                            size: 'md',
                            resolve: {
                                modalTitle: () => {
                                    return { value: 'principal.companies_details.inconsistency_data' };
                                },
                                modalCancelButtonText: () => {
                                    return { value: 'commons.edit' };
                                },
                                modalConfirmButtonText: () => {
                                    return { value: 'commons.confirm' };
                                },
                                data: () => {
                                    return {
                                        gis: {
                                            idNational: res.siren,
                                            idFiscal: res.tvaIntraco,
                                            do: res.company,
                                        },
                                        current: {
                                            idNational: this.legalEntity.idNational,
                                            idFiscal: this.legalEntity.idFiscal,
                                            do: this.principal.detail.eid,
                                        },
                                    };
                                },
                            },
                            backdrop: 'static',
                            keyboard: false,
                        })
                        .result.then(
                            () => {
                                this.proceedSave(this.legalEntity.id);
                            },
                            () => {}
                        );
                } else {
                    this.proceedSave(this.isUpdating());
                }
            },
            err => {
                this.logger.error('error.functional.retrive_gis_company_err', err);
            }
        );
    }
    controlEreportingInput() {
        if (this.legalEntity.vatRegime == null && (this.checkIfEreportingBuyer() || this.checkIfEreportingSeller())) {
            this.logger.error('Veuillez sélectionner un régime de TVA.');
            return false;
        }
        return true;
    }

    checkIfEreportingSeller() {
        if (this.shwoPdpEm && this.legalEntity.ereporting.sellerSetting != null) {
            return (this.legalEntity.ereporting.sellerSetting.transactionComplete || this.legalEntity.ereporting.sellerSetting.paymentComplete);
        }
        return false;
    }

    checkIfEreportingBuyer() {
        if (this.shwoPdpRe && this.legalEntity.ereporting.buyerSetting != null) {
            return this.legalEntity.ereporting.buyerSetting.transactionComplete;
        }
        return false;
    }

    update() {
        this.setPdpBeforSave();
        this.validatePlatformCompanyData();
        if (this.form.$valid && this.sensPlatformForLegIsUnique() && this.controlEreportingInput()) {
            this.prepareDataBeforeSave();
            this.PrincipalSvc.updateLegalEntity(
                {
                    legalEntity: this.legalEntity,
                    createDematAccount: this.createDematAccount,
                    specificDematConfig: this.plateformLegIsActive,
                },
                this.principal.detail.id
            ).then(
                data => {
                    this._initialLegalEntity = angular.copy(data);
                    this.logger.success('success.update', data, null, {entityName: 'La société'});
                    if (data.creationDematAccountFailed) {
                        this.logger.error('principal.company.demat_account_err', data, null, {
                            entityName: 'La société',
                        });
                    }
                    window.location.reload();
                },
                error => {
                    if (error.status === 400 && error.data) {
                        switch (error.data.code) {
                            case 'ENTITY_ALREADY_EXISTS_WITH_SAME_LEGAL_FISCAL_IDS':
                                this.logger.error('error.functional.entity_exists_with_same_idents');
                                break;
                            case 'ENTITY_ALREADY_EXISTS_WITH_SAME_FISCAL_ID':
                                this.logger.error('error.functional.entity_already_exists_with_same_fiscal_id');
                                break;
                            case 'ENTITY_ALREADY_EXISTS_WITH_SAME_LEGAL_ID':
                                this.logger.error('error.functional.entity_already_exists_with_same_legal_id');
                                break;
                            case 'IDENTIFIERS_INCONSISTENT':
                                this.logger.error('error.functional.identifiers_inconsistent');
                                break;
                            case 'INVALID_FISCAL_ID':
                                this.logger.error('error.functional.invalid_fiscal_id');
                                break;
                            case 'INVALID_NATIONAL_ID':
                                this.logger.error('error.functional.invalid_national_id');
                                break;
                            case 'PAYMENT_NOT_ALLOWED':
                                this.logger.error('error.functional.payment_not_allowed');
                                break;
                            case 'BENEFICIARY_UNALLOWED_IDENTIFIERS':
                                this.logger.error('error.functional.beneficiary_unallowed_identifiers');
                                break;
                            case 'START_DATE_PDP_INVALID':
                                this.logger.error('error.functional.start_date_pdp_invalid');
                                break;
                            case 'FACTURX_EXCHANGE_DIRECTORY_NOT_SPECIFIED':
                                this.logger.error(
                                    'error.functional.facturX_exchange_directory_not_specified',
                                    null,
                                    null,
                                    null,
                                    8000
                                );
                                break;
                            case 'DUPLICATE_IDENTIFIER_KIND':
                                this.logger.error('error.functional.duplicate_identifier_kind');
                                break;
                            case 'DATE_PEPPOL_IDENTIFIER_INVALID':
                                this.logger.error('error.functional.date_peppol_identifier_invalid');
                                break;
                            case 'REQUIRED_TYPE_IDENTIFIER':
                                this.logger.error(error.data.message);
                                break;
                            default:
                                break;
                        }
                    } else if (error.data && error.data.code === 'PAYMENT_KO') {
                        this.logger.error('error.functional.payment_ko');
                    } else {
                        // Echec
                        this.logger.error('error.save', error);
                    }
                }
            );
        } else if (this.canShowStartDatePdPReToasterError()) {
            this.logger.error(
                'La date de début de PDP de réception doit être supérieure ou égale à la date du jour'
            );
        } else if (this.canShowEndDatePdPReToasterError()) {
            this.logger.error(
                'La date de fin de PDP de réception doit être supérieure ou égale à la date de début et à la date du jour'
            );
        } else if (this.canShowStartDatePdPEmToasterError()) {
            this.logger.error("La date de début de PDP d'émission doit être supérieure ou égale à la date du jour");
        } else if (this.canShowEndDatePdPEmToasterError()) {
            this.logger.error(
                "La date de fin de PDP d'émission doit être supérieure ou égale à la date de début et à la date du jour"
            );
        } else if (this.canShowStartDateEreportingReToasterError()) {
            this.logger.error("La date de début du e-reporting de réception doit être supérieure ou égale à la date du jour");
        } else if (this.canShowEndDateEreportingReToasterError()) {
            this.logger.error("La date de fin du e-reporting de réception doit être supérieure ou égale à la date de début et à la date du jour");
        } else if (this.canShowStartDateEreportingEmToasterError()) {
            this.logger.error("La date de début du e-reporting d'émission doit être supérieure ou égale à la date du jour");
        } else if (this.canShowEndDateEreportingEmToasterError()) {
            this.logger.error("La date de fin du e-reporting d'émission doit être supérieure ou égale à la date de début et à la date du jour");
        } else {
            this.configPlatformErrors();
        }

    }

    setPdpBeforSave() {
        this.setPdpRe();
        this.setEreportingEm();
        this.setEreportingRe();
        this.updatePdp(
            'pdpEm',
            'pdpStartDateEm',
            'pdpEndDateEm'
        );
        this.updatePdp(
            'pdpRe',
            'pdpStartDateRe',
            'pdpEndDateRe'
        );
        const sellerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting;
        const buyerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting;
        this.updateEreporting(
            'sellerSetting',
            'eReportingStartDateEm',
            'eReportingEndDateEm',
            (sellerSetting && sellerSetting.transactionComplete) || false,
            (sellerSetting && sellerSetting.paymentComplete) || false
        );
        this.updateEreporting(
            'buyerSetting',
            'eReportingStartDateRe',
            'eReportingEndDateRe',
            (buyerSetting && buyerSetting.transactionComplete) || false,
            null
        );
    }

    updatePdp(entityKey, startDateField, endDateField) {
        const entity = this.legalEntity[entityKey];

        if (entity && entity.startDate) {
            entity.startDate = this.formatDate(this.form[startDateField].$viewValue);
            entity.endDate = entity.endDate ? this.formatDate(this.form[endDateField].$viewValue) : null;
        }
    }

    updateEreporting(reportKey, startDateField, endDateField, transactionComplete, paymentComplete) {
        const sellerOrBuyerSetting = this.legalEntity.ereporting[reportKey];

        if (sellerOrBuyerSetting && sellerOrBuyerSetting.startDate) {
            sellerOrBuyerSetting.startDate = this.formatDate(this.form[startDateField].$viewValue);
            sellerOrBuyerSetting.endDate = sellerOrBuyerSetting.endDate ? this.formatDate(this.form[endDateField].$viewValue) : null;
            sellerOrBuyerSetting.transactionComplete = transactionComplete;
            if (reportKey === 'sellerSetting') {
                sellerOrBuyerSetting.paymentComplete = paymentComplete;
            }
        }
    }

    setPdpRe() {
        if (this.legalEntity.pdpRe) {
            const startDate = this.form.pdpStartDateRe.$viewValue
                ? this.formatDate(this.form.pdpStartDateRe.$viewValue)
                : null;
            const endDate = this.form.pdpEndDateRe.$viewValue
                ? this.formatDate(this.form.pdpEndDateRe.$viewValue)
                : null;

            if (startDate) {
                this.legalEntity.pdpRe.startDate = startDate;
                this.legalEntity.pdpRe.endDate = endDate;
            }
        }
    }

    setEreportingEm() {
        if (this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting) {
            const sellerSetting = this.legalEntity.ereporting.sellerSetting;
            const startDate = this.form.eReportingStartDateEm.$viewValue
                ? this.formatDate(this.form.eReportingStartDateEm.$viewValue)
                : null;
            const endDate = this.form.eReportingEndDateEm.$viewValue
                ? this.formatDate(this.form.eReportingEndDateEm.$viewValue)
                : null;

            const transactionComplete = sellerSetting.transactionComplete ? sellerSetting.transactionComplete : false;
            const paymentComplete = sellerSetting.paymentComplete ? sellerSetting.paymentComplete : false;

            if (startDate) {
                sellerSetting.startDate = startDate;
                sellerSetting.endDate = endDate;
                sellerSetting.transactionComplete = transactionComplete;
                sellerSetting.paymentComplete = paymentComplete;
            }
        }
    }

    setEreportingRe() {
        if (this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting) {
            const buyerSetting = this.legalEntity.ereporting.buyerSetting;
            const startDate = this.form.eReportingStartDateRe.$viewValue
                ? this.formatDate(this.form.eReportingStartDateRe.$viewValue)
                : null;
            const endDate = this.form.eReportingEndDateRe.$viewValue
                ? this.formatDate(this.form.eReportingEndDateRe.$viewValue)
                : null;

            const transactionComplete = buyerSetting.transactionComplete ? buyerSetting.transactionComplete : false;

            if (startDate) {
                buyerSetting.startDate = startDate;
                buyerSetting.endDate = endDate;
                buyerSetting.transactionComplete = transactionComplete;
            }
        }
    }

    formatDateForPdp(date) {
        if (!date) return null;
        return moment(date).local().startOf('day').format('YYYY-MM-DD');
    }

    /**  Initialise la section de plateforme de démat niveau société en se basant sur le paramétrage DO ou société
     */
    initPlatformData() {
        const selectPlatform = (platform, isGis) => {
            if (isGis) {
                this.gisPlatform = platform;
                this.gisPlatformSelected = true;
            } else {
                this.pasrelPlatform = platform;
                this.pasrelPlatformSelected = true;
            }
        };
        //Config platform niveau société existant
        if (this.legalEntity.legalEntityPlatform.length > 0) {
            this.plateformLegIsActive = true;
            this.legalEntity.legalEntityPlatform.forEach(element => {
                if (element.family === this.gisPlatformName) {
                    selectPlatform(element, true);
                } else if (element.family === this.pasrelPlatformName) {
                    selectPlatform(element, false);
                }
            });

            this.principal.detail.dematPlatforms.forEach(element => {
                if (element.family === this.gisPlatformName) {
                    this.doGisPlatform = angular.copy(element);
                } else if (element.family === this.pasrelPlatformName) {
                    this.doPasrelPlatform = angular.copy(element);
                }
            });
            //Config platform niveau société non existant
        } else if (this.principal.detail.dematPlatforms.length > 0) {
            this.principal.detail.dematPlatforms.forEach(element => {
                if (element.family === this.gisPlatformName) {
                    selectPlatform(element, true);
                    this.doGisPlatform = angular.copy(element);
                } else if (element.family === this.pasrelPlatformName) {
                    selectPlatform(element, false);
                    this.doPasrelPlatform = angular.copy(element);
                }
            });
        }
    }

    /**  Permet de réinitialiser la section de plateforme de démat niveau société en se basant sur le paramétrage DO
     */
    configurePlateformLegEntFromDo() {
        if (!this.plateformLegIsActive) {
            if (this.principal.detail.dematPlatforms.length > 0) {
                this.principal.detail.dematPlatforms.forEach(element => {
                    if (element.family === this.gisPlatformName) {
                        this.gisPlatformSelected = true;
                        this.gisPlatform = this.doGisPlatform;
                    } else if (element.family === this.pasrelPlatformName) {
                        this.pasrelPlatformSelected = true;
                        this.pasrelPlatform = this.doPasrelPlatform;
                    }
                });
            }
        }
    }

    /**  Gére les erreurs liés à la section de plateforme de démat niveau société
     */
    configPlatformErrors() {
        if (this.plateformLegIsActive) {
            //aucune platforme n'est cochée
            if (!this.gisPlatformSelected && !this.pasrelPlatformSelected) {
                this.logger.error('Veuillez sélectionner au moins GIS ou PASREL comme plateforme de dématérialisation');
                //plateforme selectionnée & aucun sens de demat des facture n'est selectionné
            } else if (
                (this.gisPlatformSelected && !this.gisPlatform.invoiceRe && !this.gisPlatform.invoiceEm) ||
                (this.pasrelPlatformSelected && !this.pasrelPlatform.invoiceRe && !this.pasrelPlatform.invoiceEm)
            ) {
                this.logger.error('Veuillez sélectionner un sens de dématérialisation Factures');
            }
        }
    }

    /**  vérifie si deux même sens de démat sont sélectionnées pour differentes plateformes
     */
    sensPlatformForLegIsUnique() {
        if (
            this.plateformLegIsActive &&
            ((this.gisPlatformSelected &&
                this.pasrelPlatformSelected &&
                this.gisPlatform.invoiceRe &&
                this.pasrelPlatform.invoiceRe) ||
                (this.gisPlatform.invoiceEm && this.pasrelPlatform.invoiceEm))
        ) {
            this.logger.error('Veuillez choisir une seule plateforme pour un même sens de flux');
            return false;
        }
        return true;
    }

    validatePaths() {
        if (!this.principal.detail.eInvoiceEntry) {
            this.legalEntity.ePlatformPath = this._initialLegalEntity.ePlatformPath;
            return this.$q.resolve(true);
        }
        if (this.ePlatformChoice === 'do') {
            this.legalEntity.ePlatformPath = null;
            this.form.ePlatformPath.$setValidity('platformPathEInvoiceNotExist', true);
            return this.$q.resolve(true);
        }

        return this.PrincipalSvc.checkFacturXExchangeDirectoryExistence(this.legalEntity.ePlatformPath)
            .then(data => {
                if (!data) {
                    this.form.ePlatformPath.$setValidity('platformPathEInvoiceNotExist', false);
                    return false;
                }
                return true;
            })
            .catch(() => {
                return false;
            });
    }

    /**  valide les données des la plateforme de démat envoyés
     */
    validatePlatformCompanyData() {
        if (this.plateformLegIsActive) {
            if (this.gisPlatformSelected && this.findPlatformIndex(this.gisPlatform) === undefined) {
                this.legalEntity.legalEntityPlatform.push(this.gisPlatform);
            }
            if (this.pasrelPlatformSelected && this.findPlatformIndex(this.pasrelPlatform) === undefined) {
                this.legalEntity.legalEntityPlatform.push(this.pasrelPlatform);
            }
        } else {
            this.legalEntity.legalEntityPlatform = [];
        }
    }

    pasrelSelectUpdated() {
        if (!this.pasrelPlatformSelected) {
            this.pasrelPlatform.invoiceRe = this.pasrelPlatform.invoiceEm = this.pasrelPlatformSelected;
            this.legalEntity.legalEntityPlatform.splice(this.findPlatformIndex(this.pasrelPlatform), 1);
        } else {
            this.pasrelPlatform.family = this.pasrelPlatformName;
            this.pasrelPlatform.platformEid = this.doPasrelPlatform.platformEid;
            this.legalEntity.legalEntityPlatform.push(this.pasrelPlatform);
        }
    }

    gisSelectUpdated() {
        if (!this.gisPlatformSelected) {
            this.gisPlatform.invoiceRe = this.gisPlatform.invoiceEm = this.gisPlatformSelected;
            this.legalEntity.legalEntityPlatform.splice(this.findPlatformIndex(this.gisPlatform), 1);
            this.disableOffreApi();
        } else {
            this.gisPlatform.family = this.gisPlatformName;
            this.gisPlatform.platformEid = this.doGisPlatform.platformEid;
            this.legalEntity.legalEntityPlatform.push(this.gisPlatform);
        }
    }

    findPlatformIndex(platform) {
        var platformIndex;
        this.legalEntity.legalEntityPlatform.forEach((principalPlatform, index) => {
            if (principalPlatform.family === platform.family) {
                platformIndex = index;
            }
        });
        return platformIndex;
    }

    isStartDatePdpReChanged() {
        let startDatePdpReChanged = false;
        if (this._initialLegalEntity.pdpRe && this._initialLegalEntity.pdpRe.startDate) {
            let currentStartDate =
                this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue
                    ? this.formatDate(this.form.pdpStartDateRe.$viewValue)
                    : moment(this.legalEntity.pdpRe.startDate);
            startDatePdpReChanged = !this._initialLegalEntity.pdpRe.startDate.isSame(currentStartDate);
        } else if (this.form && this.form.pdpStartDateRe && this.form.pdpStartDateRe.$viewValue) {
            startDatePdpReChanged = true;
        }
        return startDatePdpReChanged;
    }

    isStartDateEreportingReChanged() {
        let startDateEreportingReChanged = false;
        if (this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.buyerSetting && this._initialLegalEntity.ereporting.buyerSetting.startDate) {
            let currentStartDate =
                this.form && this.form.eReportingStartDateRe && this.form.eReportingStartDateRe.$viewValue
                    ? this.formatDate(this.form.eReportingStartDateRe.$viewValue)
                    : moment(this.legalEntity.ereporting.buyerSetting.startDate);
            startDateEreportingReChanged = !moment(this._initialLegalEntity.ereporting.buyerSetting.startDate).isSame(currentStartDate);
        } else if (this.form && this.form.eReportingStartDateRe && this.form.eReportingStartDateRe.$viewValue) {
            startDateEreportingReChanged = true;
        }
        return startDateEreportingReChanged;
    }

    isStartDatePdpEmChanged() {
        let startDatePdpEmChanged = false;
        if (this._initialLegalEntity.pdpEm && this._initialLegalEntity.pdpEm.startDate) {
            let currentStartDate =
                this.form && this.form.pdpStartDateEm && this.form.pdpStartDateEm.$viewValue
                    ? this.formatDate(this.form.pdpStartDateEm.$viewValue)
                    : moment(this.legalEntity.pdpEm.startDate);
            startDatePdpEmChanged = !this._initialLegalEntity.pdpEm.startDate.isSame(currentStartDate);
        } else if (this.form && this.form.pdpStartDateEm && this.form.pdpStartDateEm.$viewValue) {
            startDatePdpEmChanged = true;
        }
        return startDatePdpEmChanged;
    }

    isStartDateEreportingEmChanged() {
        let startDateEreportingEmChanged = false;
        if (this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.sellerSetting && this._initialLegalEntity.ereporting.sellerSetting.startDate) {
            let currentStartDate =
                this.form && this.form.eReportingStartDateEm && this.form.eReportingStartDateEm.$viewValue
                    ? this.formatDate(this.form.eReportingStartDateEm.$viewValue)
                    : moment(this.legalEntity.ereporting.sellerSetting.startDate);
            startDateEreportingEmChanged = !moment(this._initialLegalEntity.ereporting.sellerSetting.startDate).isSame(currentStartDate);
        } else if (this.form && this.form.eReportingStartDateEm && this.form.eReportingStartDateEm.$viewValue) {
            startDateEreportingEmChanged = true;
        }
        return startDateEreportingEmChanged;
    }

    isEndDatePdpReChanged() {
        let EndPdpReChanged = false;
        if (this._initialLegalEntity.pdpRe && this._initialLegalEntity.pdpRe.endDate) {
            let currentEndDate =
                this.form && this.form.pdpEndDateRe && this.form.pdpEndDateRe.$viewValue
                    ? this.formatDate(this.form.pdpEndDateRe.$viewValue)
                    : moment(this.legalEntity.pdpRe.endDate);
            EndPdpReChanged = !this._initialLegalEntity.pdpRe.endDate.isSame(currentEndDate);
        } else if (this.form && this.form.pdpEndDateRe && this.form.pdpEndDateRe.$viewValue) {
            EndPdpReChanged = true;
        }
        return EndPdpReChanged;
    }

    isEndDateEreportingReChanged() {
        let endEreportingReChanged = false;
        if (this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.buyerSetting && this._initialLegalEntity.ereporting.buyerSetting.endDate) {
            let currentEndDate =
                this.form && this.form.eReportingEndDateRe && this.form.eReportingEndDateRe.$viewValue
                    ? this.formatDate(this.form.eReportingEndDateRe.$viewValue)
                    : moment(this.legalEntity.ereporting.buyerSetting.endDate);
            endEreportingReChanged = !moment(this._initialLegalEntity.ereporting.buyerSetting.endDate).isSame(currentEndDate);
        } else if (this.form && this.form.eReportingEndDateRe && this.form.eReportingEndDateRe.$viewValue) {
            endEreportingReChanged = true;
        }
        return endEreportingReChanged;
    }
    isEndDatePdpEmChanged() {
        let EndPdpEmChanged = false;
        if (this._initialLegalEntity.pdpEm && this._initialLegalEntity.pdpEm.endDate) {
            let currentEndDate =
                this.form && this.form.pdpEndDateEm && this.form.pdpEndDateEm.$viewValue
                    ? this.formatDate(this.form.pdpEndDateEm.$viewValue)
                    : moment(this.legalEntity.pdpEm.endDate);
            EndPdpEmChanged = !this._initialLegalEntity.pdpEm.endDate.isSame(currentEndDate);
        } else if (this.form && this.form.pdpEndDateEm && this.form.pdpEndDateEm.$viewValue) {
            EndPdpEmChanged = true;
        }
        return EndPdpEmChanged;
    }
    isEndDateEreportingEmChanged() {
        let endEreportingEmChanged = false;
        if (this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.sellerSetting && this._initialLegalEntity.ereporting.sellerSetting.endDate) {
            let currentEndDate =
                this.form && this.form.eReportingEndDateEm && this.form.eReportingEndDateEm.$viewValue
                    ? this.formatDate(this.form.eReportingEndDateEm.$viewValue)
                    : moment(this.legalEntity.ereporting.sellerSetting.endDate);
            endEreportingEmChanged = !moment(this._initialLegalEntity.ereporting.sellerSetting.endDate).isSame(currentEndDate);
        } else if (this.form && this.form.eReportingEndDateEm && this.form.eReportingEndDateEm.$viewValue) {
            endEreportingEmChanged = true;
        }
        return endEreportingEmChanged;
    }

    datePdpReChanged() {
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
        this.isDatePdpReChanged = this.isStartDatePdpReChanged() || this.isEndDatePdpReChanged();
        return this.isDatePdpReChanged;
    }
    dateEreportingReChanged() {
        this.canEditStartDateEreportingRe = this.isEditableStartDateEreportingRe();
        this.isDateEreportingReChanged = this.isStartDateEreportingReChanged() || this.isEndDateEreportingReChanged();
        return this.isDateEreportingReChanged;
    }
    datePdpEmChanged() {
        this.canEditStartDatePdpEm = this.isEditableStartDatePdpEm();
        this.isDatePdpEmChanged = this.isStartDatePdpEmChanged() || this.isEndDatePdpEmChanged();
        return this.isDatePdpEmChanged;
    }
    dateEreportingEmChanged() {
        this.canEditStartDateEreportingEm = this.isEditableStartDateEreportingEm();
        this.isDateEreportingEmChanged = this.isStartDateEreportingEmChanged() || this.isEndDateEreportingEmChanged();
        return this.isDateEreportingEmChanged;
    }
    isEditableStartDatePdpRe() {
        let initialStartDate =
            this._initialLegalEntity.pdpRe && this._initialLegalEntity.pdpRe.startDate
                ? moment(this._initialLegalEntity.pdpRe.startDate)
                : null;
        let initialEndDate =
            this._initialLegalEntity.pdpRe && this._initialLegalEntity.pdpRe.endDate
                ? moment(this._initialLegalEntity.pdpRe.endDate)
                : null;
        if (this.pdpReIsActive) {
            if (
                !this._initialLegalEntity.pdpRe ||
                !this._initialLegalEntity.pdpRe.startDate ||
                !this.legalEntity.pdpRe ||
                !this.legalEntity.pdpRe.startDate
            ) {
                return true;
            } else if (
                initialStartDate &&
                initialStartDate.isAfter(this.todayDate) &&
                !initialStartDate.isSame(this.todayDate)
            ) {
                return true;
            } else if (
                this.legalEntity.pdpRe &&
                this.legalEntity.pdpRe.endDate &&
                initialEndDate &&
                initialEndDate.isBefore(this.todayDate) &&
                !initialEndDate.isSame(this.todayDate)
            ) {
                return true;
            }
        }
        return false;
    }
    isEditableStartDateEreportingRe() {
        const currentBuyerSetting = this.legalEntity && this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting;
        if (currentBuyerSetting && currentBuyerSetting.transactionComplete) {
            return true;
        }
        if (!this.eReportingReIsActive) {
            return false;
        }

        const initialBuyerSetting = this._initialLegalEntity && this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.buyerSetting;

        if (!initialBuyerSetting || !initialBuyerSetting.startDate || !currentBuyerSetting || !currentBuyerSetting.startDate) {
            return true;
        }

        const initialStartDate = initialBuyerSetting && initialBuyerSetting.startDate ? moment(initialBuyerSetting.startDate) : null;
        if (this.isInitialStartDateInFuture(initialStartDate)) {
            return true;
        }
        const initialEndDate = initialBuyerSetting && initialBuyerSetting.endDate ? moment(initialBuyerSetting.endDate) : null;
        if (this.isInitialEndDateInPast(currentBuyerSetting, initialEndDate)) {
            return true;
        }
        return false;
    }
    isEditableStartDatePdpEm() {
        let initialStartDate =
            this._initialLegalEntity.pdpEm && this._initialLegalEntity.pdpEm.startDate
                ? moment(this._initialLegalEntity.pdpEm.startDate)
                : null;
        let initialEndDate =
            this._initialLegalEntity.pdpEm && this._initialLegalEntity.pdpEm.endDate
                ? moment(this._initialLegalEntity.pdpEm.endDate)
                : null;
        if (this.pdpEmIsActive) {
            if (
                !this._initialLegalEntity.pdpEm ||
                !this._initialLegalEntity.pdpEm.startDate ||
                !this.legalEntity.pdpEm ||
                !this.legalEntity.pdpEm.startDate
            ) {
                return true;
            } else if (
                initialStartDate &&
                initialStartDate.isAfter(this.todayDate) &&
                !initialStartDate.isSame(this.todayDate)
            ) {
                return true;
            } else if (
                this.legalEntity.pdpEm &&
                this.legalEntity.pdpEm.endDate &&
                initialEndDate &&
                initialEndDate.isBefore(this.todayDate) &&
                !initialEndDate.isSame(this.todayDate)
            ) {
                return true;
            }
        }
        return false;
    }
    isEditableStartDateEreportingEm() {
        const currentSellerSetting = this.legalEntity && this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting;
        if (
            currentSellerSetting &&
            (currentSellerSetting.transactionComplete || currentSellerSetting.paymentComplete)
        ) {
            return true;
        }
        if (!this.eReportingEmIsActive) {
            return false;
        }

        const initialSellerSetting = this._initialLegalEntity && this._initialLegalEntity.ereporting && this._initialLegalEntity.ereporting.sellerSetting;

        if (!initialSellerSetting || !initialSellerSetting.startDate || !currentSellerSetting || !currentSellerSetting.startDate) {
            return true;
        }

        const initialStartDate = initialSellerSetting && initialSellerSetting.startDate ? moment(initialSellerSetting.startDate) : null;
        if (this.isInitialStartDateInFuture(initialStartDate)) {
            return true;
        }
        const initialEndDate = initialSellerSetting && initialSellerSetting.endDate ? moment(initialSellerSetting.endDate) : null;
        if (this.isInitialEndDateInPast(currentSellerSetting, initialEndDate)) {
            return true;
        }
        return false;
    }
    isInitialStartDateInFuture(initialStartDate) {
        return (initialStartDate && initialStartDate.isAfter(this.todayDate) && !initialStartDate.isSame(this.todayDate));
    }
    isInitialEndDateInPast(currentBuyerOrSellerSetting, initialEndDate) {
        return (currentBuyerOrSellerSetting.endDate && initialEndDate && initialEndDate.isBefore(this.todayDate) && !initialEndDate.isSame(this.todayDate));
    }
    isPdpReActive() {
        let today = moment(this.TIME_MASK);
        if (
            !this._initialLegalEntity.pdpRe ||
            (this._initialLegalEntity.pdpRe &&
                today.isAfter(this._initialLegalEntity.pdpRe.startDate) &&
                !today.isSame(this._initialLegalEntity.pdpRe.startDate) &&
                this._initialLegalEntity.pdpRe.endDate &&
                today.isAfter(this._initialLegalEntity.pdpRe.endDate) &&
                !today.isSame(this._initialLegalEntity.pdpRe.endDate))
        ) {
            return false;
        }
        return true;
    }
    isEreportingReActive() {
        let today = moment(this.TIME_MASK);
        let ereporting = this._initialLegalEntity.ereporting;
        if (!ereporting || !ereporting.buyerSetting) {
            return false;
        }
        let buyerSetting = ereporting.buyerSetting;
        if (
            today.isAfter(buyerSetting.startDate) &&
            !today.isSame(buyerSetting.startDate) &&
            buyerSetting.endDate &&
            today.isAfter(buyerSetting.endDate) &&
            !today.isSame(buyerSetting.endDate)
        ) {
            return false;
        }
        return true;
    }
    isPdpEmActive() {
        let today = moment(this.TIME_MASK);
        if (
            !this._initialLegalEntity.pdpEm ||
            (this._initialLegalEntity.pdpEm &&
                today.isAfter(this._initialLegalEntity.pdpEm.startDate) &&
                !today.isSame(this._initialLegalEntity.pdpEm.startDate) &&
                this._initialLegalEntity.pdpEm.endDate &&
                today.isAfter(this._initialLegalEntity.pdpEm.endDate) &&
                !today.isSame(this._initialLegalEntity.pdpEm.endDate))
        ) {
            return false;
        }
        return true;
    }
    isEreportingEmActive() {
        let today = moment(this.TIME_MASK);
        let ereporting = this._initialLegalEntity.ereporting;
        if (!ereporting || !ereporting.sellerSetting) {
            return false;
        }
        let sellerSetting = ereporting.sellerSetting;
        if (
            today.isAfter(sellerSetting.startDate) &&
            !today.isSame(sellerSetting.startDate) &&
            sellerSetting.endDate &&
            today.isAfter(sellerSetting.endDate) &&
            !today.isSame(sellerSetting.endDate)
        ) {
            return false;
        }
        return true;
    }

    /**  applique les action de la régles SY-25398 au moment de décocher la case d'activation / désactivation
     *  de la PDP d'une société
     */
    activeSyPdpRe() {
        // verifie si la date de debut est modifiable
        this.canEditStartDatePdpRe = this.isEditableStartDatePdpRe();
        if (!this.pdpReIsActive) {
            // verifie l'evenement décocher la case
            this.uncheckAllEreportingRe();
            if (this._initialLegalEntity.pdpRe) {
                if (
                    this._initialLegalEntity.pdpRe.startDate.isAfter(this.todayDate) &&
                    !this._initialLegalEntity.pdpRe.startDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrée en base et que période future vider les champs
                    this.clearStartPpdRe();
                    this.clearEndPpdRe();
                } else if (
                    this._initialLegalEntity.pdpRe.startDate.isBefore(this.todayDate) &&
                    this._initialLegalEntity.pdpRe.endDate &&
                    this._initialLegalEntity.pdpRe.endDate.isBefore(this.todayDate) &&
                    !this._initialLegalEntity.pdpRe.startDate.isSame(this.todayDate) &&
                    !this._initialLegalEntity.pdpRe.endDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrer en base et que période achevée afficher les valeurs sauvegardées en base
                    this.clearStartPpdRe();
                    this.clearEndPpdRe();
                    this.legalEntity.pdpRe.startDate = this._initialLegalEntity.pdpRe.startDate;
                    this.legalEntity.pdpRe.endDate = this._initialLegalEntity.pdpRe.endDate;
                } else if (
                    this._initialLegalEntity.pdpRe.startDate.isBefore(this.todayDate) ||
                    this._initialLegalEntity.pdpRe.startDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrée en base et que période en cours mettre la date du jour au niveau de <Date de fin>
                    this.clearEndPpdRe();
                    this.legalEntity.pdpRe.endDate = this.todayDate;
                }
            } else if (this.legalEntity.pdpRe) {
                // Si aucune période n'est enregistrée en base, vider les champs
                this.clearStartPpdRe();
                this.clearEndPpdRe();
            }
            this.datePdpReChanged();
        }
    }

    activeSyEreportingRe() {
        // verifie si la date de debut est modifiable
        this.canEditStartDateEreportingRe = this.isEditableStartDateEreportingRe();
        const buyerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting;
        if (!buyerSetting) {
            return;
        }
        if (!buyerSetting.transactionComplete) {
            // Case décochée : si une date de début est saisie (initiale ou courante),
            // on ferme la période en mettant la date de fin à aujourd'hui.
            // Sinon, rien à clôturer, on vide les deux champs.
            if (buyerSetting.startDate) {
                this.clearEndEreportingRe();
                buyerSetting.endDate = this.todayDate;
            } else {
                this.clearStartEreportingRe();
                this.clearEndEreportingRe();
            }
        } else {
            // Cas inverse : la case vient d'être (re)cochée, on retire la date de fin
            // pour rouvrir la période
            this.clearEndEreportingRe();
        }
        this.dateEreportingReChanged();
    }

    /**
     * Le reporting SAF-T ne peut être activé que si la certification des factures est activée
     */
    activePtInvoiceCertification() {
        if (!this.legalEntity.ptInvoiceCertification) {
            this.legalEntity.ptReportingSaft = false;
        }
    }

    /**
     * Indique si l’on a le droit d’afficher le bloc de paramétrage des mandats.
     */
    canShowBlockSettingMandats() {
        return this.legalEntity.countryCode === 'PT' && this.principal.detail.profilSeller;
    }

    /**  applique les action de la régles SY-25398 au moment de décocher la case d'activation / désactivation
     *  de la PDP d'une société
     */
    activeSyPdpEm() {
        // verifie si la date de debut est modifiable
        this.canEditStartDatePdpEm = this.isEditableStartDatePdpEm();
        if (!this.pdpEmIsActive) {
            // verifie l'evenement décocher la case
            this.uncheckAllEreportingEm();
            if (this._initialLegalEntity.pdpEm) {
                if (
                    this._initialLegalEntity.pdpEm.startDate.isAfter(this.todayDate) &&
                    !this._initialLegalEntity.pdpEm.startDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrée en base et que période future vider les champs
                    this.clearStartPpdEm();
                    this.clearEndPpdEm();
                } else if (
                    this._initialLegalEntity.pdpEm.startDate.isBefore(this.todayDate) &&
                    this._initialLegalEntity.pdpEm.endDate &&
                    this._initialLegalEntity.pdpEm.endDate.isBefore(this.todayDate) &&
                    !this._initialLegalEntity.pdpEm.startDate.isSame(this.todayDate) &&
                    !this._initialLegalEntity.pdpEm.endDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrer en base et que période achevée afficher les valeurs sauvegardées en base
                    this.clearStartPpdEm();
                    this.clearEndPpdEm();
                    this.legalEntity.pdpEm.startDate = this._initialLegalEntity.pdpEm.startDate;
                    this.legalEntity.pdpEm.endDate = this._initialLegalEntity.pdpEm.endDate;
                } else if (
                    this._initialLegalEntity.pdpEm.startDate.isBefore(this.todayDate) ||
                    this._initialLegalEntity.pdpEm.startDate.isSame(this.todayDate)
                ) {
                    // Si une période est déjà enregistrée en base et que période en cours mettre la date du jour au niveau de <Date de fin>
                    this.clearEndPpdEm();
                    this.legalEntity.pdpEm.endDate = this.todayDate;
                }
            } else if (this.legalEntity.pdpEm) {
                // Si aucune période n'est enregistrée en base, vider les champs
                this.clearStartPpdEm();
                this.clearEndPpdEm();
            }
            this.datePdpEmChanged();
        }
    }

    activeSyEreportingEm() {
        // verifie si la date de debut est modifiable
        this.canEditStartDateEreportingEm = this.isEditableStartDateEreportingEm();
        // côté EM (seller), la section est active si au moins l'un des deux booléens est coché
        const sellerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting;
        if (!sellerSetting) {
            return;
        }
        const ereportingEmActive = sellerSetting.transactionComplete || sellerSetting.paymentComplete;
        if (!ereportingEmActive) {
            // Aucun des deux booléens n'est coché : si une date de début est saisie
            // (initiale ou courante), on ferme la période en mettant la date de fin à aujourd'hui.
            // Sinon, rien à clôturer, on vide les deux champs.
            if (sellerSetting.startDate) {
                this.clearEndEreportingEm();
                sellerSetting.endDate = this.todayDate;
            } else {
                this.clearStartEreportingEm();
                this.clearEndEreportingEm();
            }
        } else {
            // Cas inverse : au moins l'un des deux booléens vient d'être (re)coché,
            // on retire la date de fin pour rouvrir la période
            this.clearEndEreportingEm();
        }
        this.dateEreportingEmChanged();
    }

    clearStartPpdEm() {
        // vide les champs des dates PDP en emission
        this.legalEntity.pdpEm.startDate = null;
        this.form.pdpStartDateEm.$setValidity('min', true);
        this.form.pdpStartDateEm.$setValidity('date', true);
        this.form.pdpStartDateEm.$setPristine();
    }
    clearStartEreportingEm() {
        // vide les champs des dates e-reporting en émission
        this.legalEntity.ereporting.sellerSetting.startDate = null;
        this.form.eReportingStartDateEm.$setValidity('min', true);
        this.form.eReportingStartDateEm.$setValidity('date', true);
        this.form.eReportingStartDateEm.$setPristine();
    }
    clearEndPpdEm() {
        // vide les champs des dates PDP en emission
        this.legalEntity.pdpEm.endDate = null;
        this.form.pdpEndDateEm.$setValidity('min', true);
        this.form.pdpEndDateEm.$setValidity('date', true);
        this.form.pdpEndDateEm.$setPristine();
    }
    clearEndEreportingEm() {
        // vide les champs des dates e-reporting en émission
        this.legalEntity.ereporting.sellerSetting.endDate = null;
        this.form.eReportingEndDateEm.$setValidity('min', true);
        this.form.eReportingEndDateEm.$setValidity('date', true);
        this.form.eReportingEndDateEm.$setPristine();
    }
    clearStartPpdRe() {
        // vide le champs de date de debut PDP en reception
        this.legalEntity.pdpRe.startDate = null;
        this.form.pdpStartDateRe.$setValidity('min', true);
        this.form.pdpStartDateRe.$setValidity('date', true);
        this.form.pdpStartDateRe.$setPristine();
    }
	clearStartEreportingRe() {
        // vide le champs de date de debut e-reporting en réception
        this.legalEntity.ereporting.buyerSetting.startDate = null;
        this.form.eReportingStartDateRe.$setValidity('min', true);
        this.form.eReportingStartDateRe.$setValidity('date', true);
        this.form.eReportingStartDateRe.$setPristine();
    }
    clearEndPpdRe() {
        // vide le champs de date de fin PDP en reception
        this.legalEntity.pdpRe.endDate = null;
        this.form.pdpEndDateRe.$setValidity('min', true);
        this.form.pdpEndDateRe.$setValidity('date', true);
        this.form.pdpEndDateRe.$setPristine();
    }
    clearEndEreportingRe() {
        // vide le champs de date de fin e-reporting en réception
        this.legalEntity.ereporting.buyerSetting.endDate = null;
        this.form.eReportingEndDateRe.$setValidity('min', true);
        this.form.eReportingEndDateRe.$setValidity('date', true);
        this.form.eReportingEndDateRe.$setPristine();
    }
    minStartEmDate() {
        if (this.shwoPdpEm)
            return this.isStartDatePdpEmChanged()
                ? this.todayDate
                : this._initialLegalEntity.pdpEm && this._initialLegalEntity.pdpEm.startDate.isBefore(this.todayDate)
                ? new Date(this._initialLegalEntity.pdpEm.startDate)
                : this.todayDate;
    }
    maxStartEmDate() {
        if (this.legalEntity.pdpEm && this.legalEntity.pdpEm.endDate) {
            return new Date(this.legalEntity.pdpEm.endDate);
        }
    }
    minEndEmDate() {
        if (
            this.isEndDatePdpEmChanged() &&
            this.legalEntity.pdpEm &&
            this.legalEntity.pdpEm.startDate &&
            moment(this.legalEntity.pdpEm.startDate).isAfter(this.todayDate)
        ) {
            return new Date(this.legalEntity.pdpEm.startDate);
        } else if (
            !this.isEndDatePdpEmChanged() &&
            this._initialLegalEntity.pdpEm &&
            this._initialLegalEntity.pdpEm.endDate &&
            !this._initialLegalEntity.pdpEm.endDate.isAfter(this.todayDate)
        ) {
            return new Date(this._initialLegalEntity.pdpEm.endDate);
        } else {
            return this.todayDate;
        }
    }
    minEndEreportingEmDate() {
        if (
            this.isEndDateEreportingEmChanged() &&
            this.legalEntity.ereporting &&
            this.legalEntity.ereporting.sellerSetting &&
            this.legalEntity.ereporting.sellerSetting.startDate &&
            moment(this.legalEntity.ereporting.sellerSetting.startDate).isAfter(this.todayDate)
        ) {
            return new Date(this.legalEntity.ereporting.sellerSetting.startDate);
        } else if (
            !this.isEndDateEreportingEmChanged() &&
            this._initialLegalEntity.ereporting &&
            this._initialLegalEntity.ereporting.sellerSetting &&
            this._initialLegalEntity.ereporting.sellerSetting.endDate &&
            !moment(this._initialLegalEntity.ereporting.sellerSetting.endDate).isAfter(this.todayDate)
        ) {
            return new Date(this._initialLegalEntity.ereporting.sellerSetting.endDate);
        } else {
            return this.todayDate;
        }
    }
    minStartEreportingEmDate() {
        if (this.shwoPdpEm)
            return this.isStartDateEreportingEmChanged()
                ? this.todayDate
                : this._initialLegalEntity.ereporting &&
                  this._initialLegalEntity.ereporting.sellerSetting &&
                  this._initialLegalEntity.ereporting.sellerSetting.startDate &&
                  moment(this._initialLegalEntity.ereporting.sellerSetting.startDate).isBefore(this.todayDate)
                ? new Date(this._initialLegalEntity.ereporting.sellerSetting.startDate)
                : this.todayDate;
    }
    maxStartEreportingEmDate() {
        if (
            this.legalEntity.ereporting &&
            this.legalEntity.ereporting.sellerSetting &&
            this.legalEntity.ereporting.sellerSetting.endDate
        ) {
            return new Date(this.legalEntity.ereporting.sellerSetting.endDate);
        }
    }
    minStartReDate() {
        if (this.shwoPdpRe)
            return this.isStartDatePdpReChanged()
                ? this.todayDate
                : this._initialLegalEntity.pdpRe && this._initialLegalEntity.pdpRe.startDate.isBefore(this.todayDate)
                ? new Date(this._initialLegalEntity.pdpRe.startDate)
                : this.todayDate;
    }
    maxStartReDate() {
        if (this.shwoPdpRe)
            return this.legalEntity.pdpRe && this.legalEntity.pdpRe.endDate
                ? new Date(this.legalEntity.pdpRe.endDate)
                : null;
    }
    minEndReDate() {
        if (
            this.isEndDatePdpReChanged() &&
            this.legalEntity.pdpRe &&
            this.legalEntity.pdpRe.startDate &&
            moment(this.legalEntity.pdpRe.startDate).isAfter(this.todayDate)
        ) {
            return new Date(this.legalEntity.pdpRe.startDate);
        } else if (
            !this.isEndDatePdpReChanged() &&
            this._initialLegalEntity.pdpRe &&
            this._initialLegalEntity.pdpRe.endDate &&
            !this._initialLegalEntity.pdpRe.endDate.isAfter(this.todayDate)
        ) {
            return new Date(this._initialLegalEntity.pdpRe.endDate);
        } else {
            return this.todayDate;
        }
    }
    minEndEreportingReDate() {
        if (
            this.isEndDateEreportingReChanged() &&
            this.legalEntity.ereporting &&
            this.legalEntity.ereporting.buyerSetting &&
            this.legalEntity.ereporting.buyerSetting.startDate &&
            moment(this.legalEntity.ereporting.buyerSetting.startDate).isAfter(this.todayDate)
        ) {
            return new Date(this.legalEntity.ereporting.buyerSetting.startDate);
        } else if (
            !this.isEndDateEreportingReChanged() &&
            this._initialLegalEntity.ereporting &&
            this._initialLegalEntity.ereporting.buyerSetting &&
            this._initialLegalEntity.ereporting.buyerSetting.endDate &&
            !moment(this._initialLegalEntity.ereporting.buyerSetting.endDate).isAfter(this.todayDate)
        ) {
            return new Date(this._initialLegalEntity.ereporting.buyerSetting.endDate);
        } else {
            return this.todayDate;
        }
    }
    minStartEreportingReDate() {
        if (this.shwoPdpRe)
            return this.isStartDateEreportingReChanged()
                ? this.todayDate
                : this._initialLegalEntity.ereporting &&
                  this._initialLegalEntity.ereporting.buyerSetting &&
                  this._initialLegalEntity.ereporting.buyerSetting.startDate &&
                  moment(this._initialLegalEntity.ereporting.buyerSetting.startDate).isBefore(this.todayDate)
                ? new Date(this._initialLegalEntity.ereporting.buyerSetting.startDate)
                : this.todayDate;
    }
    maxStartEreportingReDate() {
        if (this.shwoPdpRe)
            return this.legalEntity.ereporting &&
                this.legalEntity.ereporting.buyerSetting &&
                this.legalEntity.ereporting.buyerSetting.endDate
                ? new Date(this.legalEntity.ereporting.buyerSetting.endDate)
                : null;
    }
    /** transforme une chaine de carac en une date
     *
     * @param dateString
     */
    formatDate(dateString) {
        if (dateString instanceof Date) {
            return moment(dateString);
        } else if (dateString) {
            const dateArray = dateString.replace(/-/g, '/').split('/');
            let formatedDate = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
            return moment(formatedDate);
        }
    }
    // Creation d'une société.
    create() {
        var CREATE_ERRORS = [
            'ERROR_COMPANY_ALREADY_EXIST',
            'INCOHERENT_ACTIVE_MATCHING_ENTITIES',
            'INCOHERENT_ACTIVE_MATCHING_ENTITY',
        ];
        this.validatePlatformCompanyData();
        if (this.form.$valid && this.sensPlatformForLegIsUnique()) {
            let creationData = this.getCreationData(null);
            creationData.checkDocumentySpaceExist = this.checkDocumentySpaceExist;
            this.PrincipalSvc.createLegalEntity(creationData, this.principal.detail.id).then(
                data => {
                    if (!data.context) {
                        this._confirmCreation(data);
                    } else if (CREATE_ERRORS.indexOf(data.context.constraint) != -1) {
                        this.logger.error(
                            'principal.companies_details.create.' + angular.lowercase(data.context.constraint),
                            null,
                            null,
                            null,
                            10000
                        );
                    } else {
                        this.openConfirmationModal(creationData, new this.CompanyCreationContextResult(data.context));
                    }
                },
                error => {
                    if (error.status === 400 && error.data) {
                        if (error.data.code === 'IDENTIFIERS_INCONSISTENT') {
                            this.logger.error('error.functional.identifiers_inconsistent');
                        } else if (error.data.code === 'INVALID_FISCAL_ID') {
                            this.logger.error('error.functional.invalid_fiscal_id');
                        } else if (error.data.code === 'INVALID_NATIONAL_ID') {
                            this.logger.error('error.functional.invalid_national_id');
                        } else if (error.data.code === 'INVALID_NATIONAL_ID') {
                            this.logger.error('error.functional.invalid_national_id');
                        } else if (error.data.code === 'PAYMENT_NOT_ALLOWED') {
                            this.logger.error('error.functional.payment_not_allowed');
                        } else if (error.data.code === 'PRINCIPAL_AND_ENTITY_HAVE_DOCUMENTARY_SPACE') {
                            this.documentarySpaceConfirmationModal(creationData);
                        } else if (error.data.code === 'FACTURX_EXCHANGE_DIRECTORY_NOT_SPECIFIED') {
                            this.logger.error(
                                'error.functional.facturX_exchange_directory_not_specified',
                                null,
                                null,
                                null,
                                8000
                            );
                        }
                    } else if (error.data && error.data.code === 'PAYMENT_KO') {
                        this.logger.error('error.functional.payment_ko');
                    } else {
                        // Echec
                        this.logger.error('error.save', error);
                    }
                }
            );
        } else {
            this.configPlatformErrors();
        }
    }

    openConfirmationModal(creationData, context) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'principal.companies_details.createtitle' };
                    },
                    modalMessage: () => {
                        return context.getConfirmationMessage();
                    },
                    modalCancelButtonText: () => {
                        this.checkDocumentySpaceExist = true;
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.confirm' };
                    },
                    data: () => {
                        return {};
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    creationData.context = context;
                    this.PrincipalSvc.createLegalEntity(creationData, this.principal.detail.id).then(
                        data => {
                            this._confirmCreation(data);
                        },
                        error => {
                            // Echec
                            this.logger.error('error.save', error);
                        }
                    );
                },
                () => {}
            );
    }

    /**
     * affiche le modal de confirmation de la création d'espace documentaire pour le DO
     */
    documentarySpaceConfirmationModal() {
        var ctrl = this;
        var messageKey = 'documentary_space.modal.message.company';
        var modalMessage = this.$translate.instant(messageKey, {
            param: this.legalEntity.name,
        });

        ctrl.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'lg',
                resolve: {
                    modalTitle: () => {
                        return { value: 'documentary_space.modal.title_check_creat' };
                    },
                    modalMessage: () => [{ key: modalMessage }],
                    modalCancelButtonText: () => {
                        this.checkDocumentySpaceExist = true;
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.confirm' };
                    },
                    data: () => null,
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(() => {
                this.checkDocumentySpaceExist = false;
                this.proceedSave(false);
            }, {});
    }

    _confirmCreation(data) {
        this._initialLegalEntity = angular.copy(data.legalEntity);
        this.logger.success('success.create', data, null, {
            entityName: 'La société',
        });
        if (data.creationDematAccountFailed) {
            this.logger.error('principal.company.demat_account_err', data, null, { entityName: 'La société' });
        }
        var previousState = this.previousState ? this.previousState.name : null;
        this.$state.go('app.principal.consult.detailscompanies', {
            legalEntityId: this._initialLegalEntity.id,
            previousState: previousState,
        });
    }

    getCreationData(context) {
        this.prepareDataBeforeSave();
        return {
            context: context,
            legalEntity: this.legalEntity,
            createDematAccount: this.createDematAccount,
            specificDematConfig: this.plateformLegIsActive,
        };
    }

    prepareDataBeforeSave() {
        if (this.legalEntity.pdpRe && this.legalEntity.pdpRe.startDate) {
            this.legalEntity.pdpRe.startDate = this.formatDate(this.form.pdpStartDateRe.$viewValue).format(
                this.DATE_FORMAT_MASK
            );
            this.legalEntity.pdpRe.endDate = this.legalEntity.pdpRe.endDate
                ? this.formatDate(this.form.pdpEndDateRe.$viewValue).format(this.DATE_FORMAT_MASK)
                : null;
        }
        if (this.legalEntity.pdpEm && this.legalEntity.pdpEm.startDate) {
            this.legalEntity.pdpEm.startDate = this.formatDate(this.form.pdpStartDateEm.$viewValue).format(
                this.DATE_FORMAT_MASK
            );
            this.legalEntity.pdpEm.endDate = this.legalEntity.pdpEm.endDate
                ? this.formatDate(this.form.pdpEndDateEm.$viewValue).format(this.DATE_FORMAT_MASK)
                : null;
        }

        if (this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting && this.legalEntity.ereporting.buyerSetting.startDate) {
            this.legalEntity.ereporting.buyerSetting.startDate = this.formatDate(this.form.eReportingStartDateRe.$viewValue).format(
                this.DATE_FORMAT_MASK
            );
            this.legalEntity.ereporting.buyerSetting.endDate = this.legalEntity.ereporting.buyerSetting.endDate
                ? this.formatDate(this.form.eReportingEndDateRe.$viewValue).format(this.DATE_FORMAT_MASK)
                : null;
        }
        if (this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting && this.legalEntity.ereporting.sellerSetting.startDate) {
            this.legalEntity.ereporting.sellerSetting.startDate = this.formatDate(this.form.eReportingStartDateEm.$viewValue).format(
                this.DATE_FORMAT_MASK
            );
            this.legalEntity.ereporting.sellerSetting.endDate = this.legalEntity.ereporting.sellerSetting.endDate
                ? this.formatDate(this.form.eReportingEndDateEm.$viewValue).format(this.DATE_FORMAT_MASK)
                : null;
        }

        if(this.legalEntity.peppolIdentifiers)
        {
            this.updateIdentifier(this.legalEntity.peppolIdentifiers[0], this.legalEntity.idFiscalKind);
            this.updateIdentifier(this.legalEntity.peppolIdentifiers[1], this.legalEntity.idNationalKind);

            // filtre les objet null avant l'envoie
            this.legalEntity.peppolIdentifiers = this.legalEntity.peppolIdentifiers.filter(
                e => e.startDate
            );
        }

        //si on choisit le platformPath du do, on reinitialise
        if (this.platformChoice === 'do') {
            this.legalEntity.platformPath = null;
        }
        if (this.ePlatformChoice === 'do') {
            this.legalEntity.ePlatformPath = null;
        }
        this.legalEntity.countryCode = this.legalEntity.country.code;
        this.legalEntity.createOrUpdateDefaultContact(
            this.principal.detail.profilSeller,
            this.principal.detail.profilBuyer
        );
    }
    updateIdentifier(identifier, kind) {
        if (identifier != null && identifier.isActive && identifier.legIdentifierKind == null) {
            identifier.legIdentifierKind = kind;
        }
    }
    initPlatformChoice() {
        if (this.legalEntity.platformPath) {
            this.platformChoice = 'soc';
        } else {
            this.platformChoice = 'do';
        }
        if (this.legalEntity.ePlatformPath) {
            this.ePlatformChoice = 'soc';
        } else {
            this.ePlatformChoice = 'do';
        }
    }

    reloadRegSchemes(country) {
        if (country) {
            this.RegistrationSchemesDA.getByCountry(country.code).then(regShemes => {
                this.regSchemes = regShemes;
                this.initRegSchemes();
                this.legalEntity.idNational = null;
                this.legalEntity.idFiscal = null;
            });
        }
    }
    exportCsv(grid) {
        var options;
        var gridApi;
        var filename;
        if (grid === 'perimeter') {
            options = this.gridPerimeterOptions;
            gridApi = this.gridApi;
            filename = 'perimetres-societe';
            this.gridPerimeterOptions.exporterFieldCallback = (grid, row, col, value) => {
                if (['beginDate', 'endDate'].indexOf(col.name) != -1) {
                    value = this.$filter('date')(value, 'shortDate');
                }
                return value;
            };
        } else if (grid === 'container') {
            options = this.gridContainerOptions;
            gridApi = this.containerGridApi;
            filename = 'containers-societe';
        }
        if (options) {
            options.exporterCsvFilename = filename + '_' + moment().format('DDMMYYYY') + '.csv';
            options.exporterHeaderFilter = this.$translate.instant;
            gridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
        }
    }

    /**
     * True si la société peut être supprimée.
     */
    isCompanyDeletable() {
        this.PrincipalSvc.isCompanyDeletable(this.legalEntity.id).then(result => {
            this.companyDeletable = result;
        });
    }

    /**
     * Supression d'une société.
     */
    deleteCompany() {
        this.$uibModal
            .open({
                component: 'modalDeleteCompany',
                size: 'lg',
                resolve: {
                    legalEntity: () => {
                        return this.legalEntity;
                    },
                },
            })
            .result.then(
                () => {
                    this.back();
                },
                () => {}
            );
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    cantEditIdFiscal() {
        return this._initialLegalEntity.idFiscal !== null;
    }

    cantEditIdNational() {
        return this._initialLegalEntity.idNational !== null;
    }

    cantEditCountry() {
        return this._initialLegalEntity.id !== null;
    }
    // afficher le bloc pdp réception uniquement en mode edition et pour pour les sociétés françaises (disposant d'un N° TVA intracommunautaire et d'un SIREN sur SY)
    canEditPdpRe() {
        return (
            this._initialLegalEntity.id !== null &&
            this.PrincipalSvc.getSocFr().includes(this.legalEntity.countryCode) &&
            this.principal.detail.profilBuyer
        );
    }
    canEditPdpEm() {
        return (
            this._initialLegalEntity.id !== null &&
            this.PrincipalSvc.getSocFr().includes(this.legalEntity.countryCode) &&
            this.principal.detail.profilSeller
        );
    }

    canShowBillingAdress() {
        return (
            this._initialLegalEntity.id !== null &&
            this.PrincipalSvc.getSocFr().includes(this.legalEntity.countryCode) &&
            this.principal.detail.profilBuyer
        );
    }
    canEditReadable() {
        return this._initialLegalEntity.id !== null;
    }

    hasOffreApiConfig() {
        return this.legalEntity.offresApi && this.legalEntity.offresApi.length > 0;
    }

    hasMandateSiiConfig() {
        return this.legalEntity.countryCode === this.COUNTRY_CODE_ES && this.principal.detail.profilSeller;
    }

    isConfigurator() {
        return this.AuthSvc.isAuthorized(this.ROLE_CONFIGURATOR);
    }

    handleMandateSiiChange() {
        if (!this.legalEntity.mandateSii.enabled) {
            this.legalEntity.mandateSii.zone = null;
        }
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut de reception PDP
     */
    canShowStartDatePdPReToasterError() {
        const pdpRe = this.legalEntity.pdpRe;
        return (
            this.datePdpReChanged() &&
            pdpRe &&
            pdpRe.startDate &&
            pdpRe.startDate.isBefore(this.todayDate)
        );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut de réception e-reporting
     */
    canShowStartDateEreportingReToasterError() {
        const buyerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.buyerSetting;
        return (
            this.dateEreportingReChanged() &&
            buyerSetting &&
            buyerSetting.startDate &&
            buyerSetting.startDate.isBefore(this.todayDate)
        );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut d'émission PDP
     */
    canShowStartDatePdPEmToasterError() {
        const pdpEm = this.legalEntity.pdpEm;
        return (
            this.datePdpEmChanged() &&
            pdpEm &&
            pdpEm.startDate &&
            pdpEm.startDate.isBefore(this.todayDate)
        );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut d'émission e-reporting
     */
    canShowStartDateEreportingEmToasterError() {
        const sellerSetting = this.legalEntity.ereporting && this.legalEntity.ereporting.sellerSetting;
        return (
            this.dateEreportingEmChanged() &&
            sellerSetting &&
            sellerSetting.startDate &&
            sellerSetting.startDate.isBefore(this.todayDate)
        );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de debut d'émission PDP
     */
    canShowEndDatePdPEmToasterError() {
        return (
            (this.isEndDatePdpEmChanged() || this.isStartDatePdpEmChanged()) &&
            this.legalEntity.pdpEm.endDate &&
            this.legalEntity.pdpEm.endDate.isBefore(this.legalEntity.pdpEm.startDate) &&
            !this.legalEntity.pdpEm.endDate.isSame(this.legalEntity.pdpEm.startDate)
        );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de fin d'émission e-reporting
     */
    canShowEndDateEreportingEmToasterError() {
    return (
        (this.isEndDateEreportingEmChanged() || this.isStartDateEreportingEmChanged()) &&
        this.legalEntity.ereporting.sellerSetting.endDate &&
        this.legalEntity.ereporting.sellerSetting.endDate.isBefore(this.legalEntity.ereporting.sellerSetting.startDate) &&
        !this.legalEntity.ereporting.sellerSetting.endDate.isSame(this.legalEntity.ereporting.sellerSetting.startDate)
    );
    }

    /**
     * Indique si on doit afficher le toaster d'erreur de la date de fin de reception PDP
     */
    canShowEndDatePdPReToasterError() {
        return (
            (this.isEndDatePdpReChanged() || this.isStartDatePdpReChanged()) &&
            this.legalEntity.pdpRe &&
            this.legalEntity.pdpRe.endDate &&
            this.legalEntity.pdpRe.endDate.isBefore(this.legalEntity.pdpRe.startDate) &&
            !this.legalEntity.pdpRe.endDate.isSame(this.legalEntity.pdpRe.startDate)
        );
    }

	/**
	 * Indique si on doit afficher le toaster d'erreur de la date de fin de réception e-reporting
	 */
	canShowEndDateEreportingReToasterError() {
	    return (
	        (this.isEndDateEreportingReChanged() || this.isStartDateEreportingReChanged()) &&
	        this.legalEntity.ereporting &&
	        this.legalEntity.ereporting.buyerSetting &&
	        this.legalEntity.ereporting.buyerSetting.endDate &&
	        this.legalEntity.ereporting.buyerSetting.endDate.isBefore(this.legalEntity.ereporting.buyerSetting.startDate) &&
	        !this.legalEntity.ereporting.buyerSetting.endDate.isSame(this.legalEntity.ereporting.buyerSetting.startDate)
	    );
	}

    /**
     * Indique si SY ou epdf est activé
     * FIXME A remplacer par KISS_ENABLED ou EPDF_ENABLE quand ca sera traité proprement. On n'aura plus besoin de tester le profil
     */
    isKissOrEpdfEnabled() {
        return (
            this.principal.detail.profilBuyer && (this.principal.kiss.paramKiss || this.principal.epdf.ladProviderEid)
        );
    }

    /**
     * Indique si SY est activé.
     * FIXME A remplacer par KISS_ENABLED quand ca sera traité proprement. On n'aura plus besoin de tester le profil
     */
    isKissEnabled() {
        return this.principal.detail.profilBuyer && this.principal.kiss.paramKiss;
    }

    /**
     * Indique si on est en mode modification de société (mode création de société sinon).
     */
    isUpdating() {
        return !!this.legalEntity.id;
    }

    /**
     * Permet de mettre à jour l'identifiant plateforme dans le cas de crétion d'une société Gis.
     */
    identifiersUpdated() {
        if (!this.legalEntity.id && this.idGisPlatformFocused) {
            this.legalEntity.dematGisId = this.legalEntity.idFiscal
                ? this.legalEntity.idFiscal
                : this.legalEntity.idNational;
        }
    }

    /**
     * Indique si le champ idPlateformGis a eu un focus.
     */
    idPlateformGisFocused() {
        this.idGisPlatformFocused = true;
    }

    // indique si le compte est client invité et a des demandes de connexion
    hasLinkRequests() {
        return this.linkRequestCount > 0;
    }

    // Affiche Liste des demandes de connexion.
    viewConnexion() {
        this.$state.go('app.link_request.seller', { id: this.legalEntity.id, principalId: this.principal.detail.id });
    }

    isPdpRe() {
        return this._initialLegalEntity.id && this._initialLegalEntity.pdpRe != null;
    }

    isPdpEm() {
        return this._initialLegalEntity.id && this._initialLegalEntity.pdpEm != null;
    }

    // Envoi à la PPF : RE
    statusPpfReSend() {
        return this.getComplianceStatus(this._initialLegalEntity.pdpRe);
    }

    // Envoi à la PPF : EM
    statusPpfEmSend() {
        return this.getComplianceStatus(this._initialLegalEntity.pdpEm);
    }

    getComplianceStatus(pdp) {
        var status = {};
        if (pdp && pdp.complianceStatus) {
            switch (pdp.complianceStatus) {
                case 'RECEIVING_ADDRESS_PERIOD_ENCLOSES':
                case 'RECEIVING_ADDRESS_PERIOD_EXPIRED':
                case 'RECEIVING_ADDRESS_REQUEST_NOT_FOUND':
                case 'RECEIVING_ADDRESS_ALREADY_EXISTS':
                    status = { color: 'red', text: 'principal.company.not_sent_to_compliance' };
                    break;
                case 'SUCCESS':
                    status = { color: 'orange', text: 'principal.company.in_progress_to_compliance' };
                    break;
            }
        }
        return status;
    }

    // Désactive l'offre API pour la société si la dématérialisation des factures entrantes n'est pas active au niveau de GIS
    disableOffreApi() {
        if (!this.gisPlatform.invoiceRe) {
            const offreApiConfig = this.getInvoiceRetrievalConfig();
            offreApiConfig.active = false;
        }
    }

    /* Indique si disable ou non offre API */
    disableOfferBlock(offreApiConfig) {
        return !this.isEditAuthorized() || (this.isInvoiceRetrieval(offreApiConfig) && !this.gisPlatform.invoiceRe);
    }

    isInvoiceRetrieval(offreApiConfig) {
        return offreApiConfig.offerApi.eid === 'INVOICE_RETRIEVAL';
    }

    getInvoiceRetrievalConfig() {
        if (this.legalEntity.offresApi) {
            return this.legalEntity.offresApi.find(config => this.isInvoiceRetrieval(config));
        }
    }

    isInvoiceRetrievalInactive(offreApiConfig) {
        return this.isInvoiceRetrieval(offreApiConfig) && !offreApiConfig.active;
    }

    // Function to filter options for Selector 2 based on the selection made in Selector 1
    filterOptionsForSelector2() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions2 = this.filtredAttributes.filter(item => {
            return item.path !== offreApiConfig.path1;
        });

        // Check if the selector was previously set and is now cleared
        if (this.previousFirstSelectorState && !offreApiConfig.path1) {
            offreApiConfig.value1 = null; // Reset the associated value
        }
        // Update the previous state of the selector
        this.previousFirstSelectorState = offreApiConfig.path1;
    }

    // Function to filter options for Selector 1 based on the selection made in Selector 2
    filterOptionsForSelector1() {
        const offreApiConfig = this.getInvoiceRetrievalConfig();
        if (!offreApiConfig) return; // If no matching config found, return

        this.filteredOptions1 = this.filtredAttributes.filter(item => {
            return item.path !== offreApiConfig.path2;
        });

        if (this.previousSecondSelectorState && !offreApiConfig.path2) {
            offreApiConfig.value2 = null; // Reset the associated value
        }
        this.previousSecondSelectorState = offreApiConfig.path2;
    }

    getReadableData() {
        this.buildGetRessourceRequest(this.getRequestDto);
        if (this.isDOCL && this.isDOFO) {
            this.getReadableDataForDOBuyerAndSeller();
        } else if (this.isDOCL) {
            this.getRequestDto.fluxType = 'E';
            this.getClientResourceVersions(this.getRequestDto).then(results => {
                this.gridReadableOptions.data = results.map(item => angular.extend({}, item, { fluxType: 'Entrant' }));
            });
        } else if (this.isDOFO) {
            this.getRequestDto.fluxType = 'S';
            this.getClientResourceVersions(this.getRequestDto).then(results => {
                this.gridReadableOptions.data = results.map(item => angular.extend({}, item, { fluxType: 'Sortant' }));
            });
        }
    }

    // Function to map fluxType to results
    appendFluxType(results, fluxType) {
        return results.map(item => Object.assign({}, item, { fluxType }));
    }

    getReadableDataForDOBuyerAndSeller() {
        const buyerRequestDto = angular.copy(this.getRequestDto);
        const sellerRequestDto = angular.copy(this.getRequestDto);
        buyerRequestDto.fluxType = 'E';
        sellerRequestDto.fluxType = 'S';
        // Function for fetching and processing client resource versions
        const fetchAndMapClientResources = (requestDto, fluxType) =>
            this.getClientResourceVersions(requestDto).then(results => this.appendFluxType(results, fluxType));

        Promise.all([
            fetchAndMapClientResources(buyerRequestDto, 'Entrant'),
            fetchAndMapClientResources(sellerRequestDto, 'Sortant'),
        ]).then(results => {
            // Merge the results
            this.gridReadableOptions.data = [...results[0], ...results[1]];
        });
    }

    buildGetRessourceRequest(requestDto) {
        requestDto.country = this.legalEntity.country.code;
        requestDto.legalIdentifier = this.legalEntity.idFiscal || '';
        requestDto.taxIdentifier = this.legalEntity.idNational || '';
    }

    buildDeleteRessourceRequest(entity) {
        this.deleteRequestDto = {};
        this.deleteRequestDto.legalEntityId = this.legalEntity.id;
        this.deleteRequestDto.taxIdentifier = this.legalEntity.idNational;
        this.deleteRequestDto.legalIdentifier = this.legalEntity.idFiscal;
        this.deleteRequestDto.dematMode = entity.dematMode;
    }

    getClientResourceVersions(requestDto) {
        return this.PrincipalSvc.getClientResourceVersions(requestDto).then(data => {
            return data.versions;
        });
    }

    deleteClientResource(entity) {
        if (this.isEditAuthorized()) {
            this.buildDeleteRessourceRequest(entity);
            this.PrincipalSvc.deleteClientResourceVersion(entity.uuid, this.deleteRequestDto).then(
                result => {
                    this.logger.success('Le lisible a été supprimé avec succès', result);
                    var index = this.gridReadableOptions.data.indexOf(entity);
                    this.gridReadableOptions.data.splice(index, 1);
                },
                error => {
                    this.logger.error("Une erreur s'est produite lors de la suppression de la ressource", error);
                }
            );
        } else {
            this.logger.error("Vous n'avez pas le droit de supprimer cette ressource");
        }
    }

    downloadClientResource(uuid) {
        this.PrincipalSvc.downloadClientResourceVersion(uuid).then(
            result => {
                this.logger.success('Le lisible a été téléchargé avec succès', result);
            },
            error => {
                this.logger.error("Une erreur s'est produite lors du téléchargement de la ressource", error);
            }
        );
    }

    initReadableGrid() {
        let donwloadReadable =
            '<div class="ui-grid-cell-contents text-center pointer"' +
            'ng-click="grid.appScope.$ctrl.downloadClientResource(row.entity.uuid)"><span><i class="fa fa-download"></i>';
        let deleteReadable =
            '<div class="ui-grid-cell-contents text-center pointer"' +
            'ng-click="grid.appScope.$ctrl.deleteClientResource(row.entity)"><span><i class="fa fa-trash"></i>';
        let formatReadableDate =
            '<div class="ui-grid-cell-contents text-center pointer">{{row.entity.creationDate | date: "dd/MM/yyyy" }}</div>';
        let isReadableDeployed = '<div class="ui-grid-cell-contents">{{ row.entity.isDeployed ? "Oui" :"Non"}}</div>';
        let getDematModeValue =
            '<div class="ui-grid-cell-contents">{{ grid.appScope.$ctrl.getDematModeValue(row.entity.dematMode) }}</div>';
        this.gridReadableOptions = {
            columnDefs: [
                {
                    name: 'version',
                    displayName: 'Version du lisible',
                    minWidth: '150',
                    sort: { direction: 'desc', priority: 2 },
                },
                {
                    name: 'isDeployed',
                    displayName: 'Déployé',
                    cellTemplate: isReadableDeployed,
                },
                {
                    name: 'fluxType',
                    displayName: 'Type de flux',
                },
                {
                    name: 'dematMode',
                    displayName: 'Mode de démat',
                    minWidth: '150',
                    sort: { direction: 'asc', priority: 1 },
                    cellTemplate: getDematModeValue,
                },
                {
                    name: 'creationDate',
                    displayName: 'Date de création',
                    minWidth: '150',
                    cellTemplate: formatReadableDate,
                },
                {
                    name: 'parameters[0].semanticPath',
                    displayName: 'Filtre 1',
                },
                {
                    name: 'parameters[0].value',
                    displayName: 'Valeur',
                },
                {
                    name: 'parameters[1].semanticPath',
                    displayName: 'Filtre 2',
                },
                {
                    name: 'parameters[1].value',
                    displayName: 'Valeur',
                },
                {
                    name: 'downloadZip()',
                    displayName: 'Télécharger',
                    cellTemplate: donwloadReadable,
                    enableSorting: false,
                },
                {
                    name: 'deleteReadable()',
                    displayName: 'Supprimer',
                    cellTemplate: deleteReadable,
                    enableSorting: false,
                },
            ],
            onRegisterApi: gridApi => {
                this.readableGridApi = gridApi;
            },
            enableColumnMenus: false,
            enableSorting: true,
            enableGridMenu: false,
            rowHeight: 30,
        };
    }

    getDematModeValue(key) {
        return this.DEMATMODE[key] || key;
    }

    openReadableModal() {
        this.$uibModal
            .open({
                component: 'legalEntityReadableImport',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    filtredAttributes: () => {
                        return this.filtredAttributes;
                    },
                    legalEntity: () => {
                        return this.legalEntity;
                    },
                },
            })
            .result.then(
                res => {
                    this.closeModal(res);
                    this.getReadableData();
                },
                () => {
                    this.dismissModal();
                }
            );
    }
}

angular.module('app.principal').component('companiesDetails', {
    templateUrl: require('./companies-details.html'),
    controller: companiesDetailsCtrl,
    bindings: {
        legalEntity: '<',
        regSchemes: '<',
        ladProviders: '<',
        countries: '<',
        principal: '<',
        offresApiConfig: '<',
        previousState: '<',
        functionalType: '<',
        dictionnaireAttributs: '<',
    },
});
